import Vue from 'vue'
import VModal from 'vue-js-modal'
import Alert from '@/components/modal/Alert'
import Confirm from '@/components/modal/Confirm'

Vue.use(VModal, {
  dynamicDefaults:{
    height: 'auto'
  }
})

export default {
  install(Vue) {
    Vue.prototype.$createConfirmResponse = function(){
      return {
        result: false,
        data: null
      }
    }

    Vue.prototype.$confirm = function(title, contents, confirmText, cancelText, response, events){
      if(!confirmText){
        confirmText = '확인';
      }
      if(!cancelText){
        cancelText = '취소';
      }
      this.$modal.show(
        Confirm,
        {
          title: title,
          contents: contents,
          confirmText: confirmText,
          cancelText: cancelText,
          response: response
        },
        null,
        events
      )
    }

    Vue.prototype.$alert = function(title, contents, confirmText, events){
      if(!confirmText){
        confirmText = '확인';
      }
      
      this.$modal.show(
        Alert,
        {
          title: title,
          contents: contents,
          confirmText: confirmText,
        },
        null,
        events,
      )
    }
  }
}